<template lang="pug">
section.tab-page-container
  is-loading(v-if="loading")

  template(v-else)
    section.table-info__list(v-if="!loading && !error && passports && passports.length")
      template(v-for="passport in passports")
        .table-info__item
          .col
            //- .row(v-if="passport.address")
              span Адрес:
                b {{ passport.address }}
            //- .row(v-if="passport.birth_date")
              span Дата рождения:
                b {{ dmy(passport.birth_date) }}
            .row(v-if="passport.first_name || passport.last_name || passport.middle_name")
              span {{ $t('profileSettings.fullName') }}:
                b(v-if="passport.first_name") {{ passport.first_name }}
                b(v-if="passport.last_name") {{ passport.last_name }}
                b(v-if="passport.middle_name") {{ passport.middle_name }}
            //- .row(v-if="passport.identity_nubmer")
              span Идентификационный номер:
                b {{ passport.identity_nubmer }}
            .row(v-if="passport.nubmer")
              span {{ $t('profileSettings.seriesAndNumber') }}:
                b {{ passport.nubmer }}
            //- .row(v-if="passport.sex")
              span Пол:
                b {{ passport.sex === 1 ? 'Мужской' : 'Женский' }}
            .row(v-if="passport.type")
              span {{ $t('profileSettings.documentType') }}:
                b {{ passport.type }}
            //- .row(v-if="passport.nationality")
              span Национальность:
                b {{ passport.nationality }}
            //- .row(v-if="passport.valid_date")
              span Действителен до:
                b {{ dmy(passport.valid_date) }}
            //- .row(v-if="passport.issue_place")
              span Место выдачи:
                b {{ passport.issue_place }}
            //- .row(v-if="passport.issue_date")
              span Дата выдачи:
                b {{ dmy(passport.issue_date) }}
          .row
            button.button.button_warning-outline(@click="edited(passport)") Изменить
            button.button.button_danger-outline(@click="deleted(passport)") Удалить
    template(v-else)
        .table-info__no-data {{ $t('profileSettings.noSavedAddr') }}
    .table-info__footer(v-if="!loading && !error")
      button.button.button_secondary-outline(@click="added") + Добавить новый документ


  transition(name="fade")
    .popup__overlay(v-if="edit.is && edit.data")
      .popup__view
        .popup__body
          .popup__close(@click="cancel")
            icon(name="close")
          .popup__header {{ $t('profileSettings.editing') }}
          .popup__main
            .cancel-label
              passport-form(v-model="edit.data")

            .popup__footer.text-center
              .row
                button.button.button_danger-outline(@click="cancel") Отмена
                button.button.button_primary-outline(@click="save") Сохранить

  transition(name="fade")
    .popup__overlay(v-if="add.is")
      .popup__view
        .popup__body
          .popup__close(@click="cancel")
            icon(name="close")
          .popup__header {{ $t('profileSettings.creation') }}
          .popup__main
            .cancel-label
              passport-form(v-model="add.model")

            .popup__footer.text-center
              .row
                button.button.button_danger-outline(@click="cancel") Отмена
                button.button.button_primary-outline(@click="create") Создать

  transition(name="fade")
    .popup__overlay(v-if="del.is && del.data")
      .popup__view
        .popup__body
          .popup__close(@click="cancel")
            icon(name="close")
          .popup__header {{ $t('profileSettings.deletingAnAddress') }}
          .popup__main
            .cancel-label

            .popup__footer.text-center
              .row
                button.button.button_danger-outline(@click="cancel") Отмена
                button.button.button_primary-outline(@click="rm") Удалить
  //- .col
      .col
        .row
          .row
            span {{ passport.id }}
            span {{ passport.is_default }}
          .row
            button.btn.btn__danger edit
            button.btn.btn__warning delete
</template>

<script>
import Icon from '@/components/Icons.vue';
import API from '@/api/api';

import PassportForm from './passport-form';

const clear = {
  first_name: '',
  last_name: '',
  middle_name: '',
  address: '',
  identity_nubmer: '',
  nubmer: '',
  sex: '',
  type: '',
  nationality: '',
  valid_date: '',
  issue_place: '',
  issue_date: '',
};

Object.freeze(clear);

export default {
  name: 'PassportsTab',
  components: {
    Icon,
    PassportForm,
  },
  data: () => ({
    passports: [],
    error: false,
    loading: false,

    edit: {
      data: null,
      is: false,
    },

    del: {
      data: null,
      is: false,
    },

    add: {
      model: {
        first_name: '',
        last_name: '',
        middle_name: '',
        address: '',
        identity_nubmer: '',
        nubmer: '',
        sex: '',
        type: '',
        nationality: '',
        valid_date: '',
        issue_place: '',
        issue_date: '',
      },
      is: false,
    },
  }),
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.loading = true;
      const data = await API.passports.get({}, (error) => {
        console.log('error', error);
        this.error = true;
        this.toggleLoader();
      });
      this.passports = data;
      this.offLoader();
    },

    offLoader() {
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },

    refetch() {
      this.error = false;
      this.fetch();
    },

    edited(data) {
      this.edit.data = data;
      this.edit.is = true;
    },
    async save() {
      await API.passports.put(this.edit.data.id, {
        ...this.edit.data,
      }, (error) => {
        console.log(error);
        global.alert('Произошла ошибка во время сохранения данных');
        this.offLoader();
      });
      this.cancel();
      this.offLoader();
    },

    deleted(data) {
      this.del.data = data;
      this.del.is = true;
    },
    async rm() {
      await API.passports.del(this.del.data.id, {
        ...this.del.data,
      }, (error) => {
        console.log(error);
        global.alert('Произошла ошибка во время удаления данных');
        this.offLoader();
      });
      this.refetch();
      this.cancel();
    },

    added() {
      this.add.is = true;
    },
    async create() {
      await API.passports.post({
        ...this.add.model,
      }, (error) => {
        console.log(error);
        global.alert('Произошла ошибка во время создания данных');
        this.offLoader();
      });
      this.refetch();
      this.cancel();
    },

    cancel() {
      this.edit.data = null;
      this.edit.is = false;

      this.del.data = null;
      this.del.is = false;

      this.add.model = { ...clear };
      this.add.is = false;
    },

    dmy(date) {
      const d = new Date(date);
      if (!d.toJSON()) {
        return '--.--.----';
      }
      const is0 = (n) => (parseInt(n, 10) < 10 ? `0${n}` : n);
      return `${is0(d.getDate())}.${is0(d.getMonth() + 1)}.${d.getFullYear()}`;
    },
  },
};
</script>

<style lang="scss"></style>
